<div class="app-sidebar sidebar-shadow" id="vbSidebar">
  <div class="scrollbar-sidebar eva-v2-styles">
    <div class="app-sidebar__inner">
      <ul class="vertical-nav-menu">
        <li
          *ngFor="let menuItem of sidebarItems$ | async"
          [ngClass]="{ 'app-sidebar__heading': menuItem.type === 'group' }"
          [class]="menuItem.displayName"
        >
          <span *ngIf="menuItem.type === 'group'">{{ menuItem.displayName | translate }}</span>
          <!-- <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i> -->
          <ul *ngIf="menuItem.subMenus?.length" class="mm-show eva-v2-submenu">
            <li
              *ngFor="let sItem of menuItem.subMenus"
              (click)="toggleChild($event)"
              (keyup.enter)="toggleChild($event)"
              tabindex="0"
            >
              <a
                [routerLink]="sItem.path ? sItem.path : null"
                routerLinkActive="mm-active"
                [routerLinkActiveOptions]="{ exact: false, __change_detection_hack__: sItem.path }"
              >
                <i class="metismenu-icon pe-7s-rocket"></i>
                {{ sItem.displayName | translate }}
                <p-badge [value]="2" *ngIf="sItem.badge"></p-badge>
                <i class="metismenu-state-icon pe-7s-angle-up caret-left" *ngIf="sItem.subMenus?.length"></i>
              </a>

              <ul *ngIf="sItem.subMenus?.length" class="inner-child-menu">
                <li *ngFor="let childItem of sItem.subMenus">
                  <a
                    [routerLink]="childItem.path"
                    routerLinkActive="mm-active"
                    [routerLinkActiveOptions]="{ exact: false, __change_detection_hack__: childItem.path }"
                    class="{{ childItem.displayName | translate | lowercase }}"
                  >
                    <i class="metismenu-icon pe-7s-rocket"></i>
                    {{ childItem.displayName | translate }}
                    <p-badge [value]="5" *ngIf="childItem.badge"></p-badge>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <!-- <li class="app-sidebar__heading">Requirements Gathering</li>
        <li>
          <a href="index.html" class="mm-active">
            <i class="metismenu-icon pe-7s-rocket"></i>
            Diagrams
          </a>
        </li> -->
      </ul>
      <!--  <div class="ps__rail-x" style="left: 0px; bottom: 0px;"><div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div></div>
      <div class="ps__rail-y" style="top: 0px; height: 543px; right: 0px;"><div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 353px;"></div></div> -->
    </div>
  </div>
</div>
